import { render, staticRenderFns } from "./SetPdfThumbnail.vue?vue&type=template&id=1fb926fe"
import script from "./SetPdfThumbnail.vue?vue&type=script&lang=js"
export * from "./SetPdfThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports